import { IconButton, Typography, Chip, Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import s from "../styles/ProductForm.module.scss";

export default function Header({ flavor, flavorColor, isAvailable, onBack }) {
    return (
        <div className={s.header}>
            <div className={s.headerLeft}>
                <div className={s.headerTopRow}>
                    <IconButton type="button" onClick={onBack} className={s.backBtn}>
                        <ArrowBackIcon />
                    </IconButton>

                    <Box className={s.headerTitles}>
                        <Typography variant="h5" className={s.title}>
                            Картка товару
                        </Typography>
                        <Typography variant="body2" className={s.subtitle}>
                            Заповни основні дані та збережи
                        </Typography>
                    </Box>
                </div>

                <div className={s.headerChips}>
                    {flavor ? (
                        <Chip label={flavor} className={s.badge} sx={{ bgcolor: flavorColor }} />
                    ) : (
                        <Chip label="Смак не вказано" className={s.badgeMuted} />
                    )}

                    <Chip
                        label={isAvailable ? "В наявності" : "Немає в наявності"}
                        className={isAvailable ? s.badgeLive : s.badgeOff}
                    />
                </div>
            </div>
        </div>
    );
}